import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  public showSpinner$ = signal<boolean>(false);

  public get loading(): boolean {
    return this.showSpinner$();
  }

  public set loading(value: boolean) {
    this.showSpinner$.set(value);
  }

  public show() {
    this.showSpinner$.set(true);
  }

  public hide() {
    this.showSpinner$.set(false);
  }
}
